import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getXochipilliDatasetDetails} from "~/workspaceConfig/hostedPages/dashboard/-api";
import {OTTOKART_QUOTATION_DASHBOARD_DATASET_ID} from "~/workspaceConfig/hostedPages/dashboard/-dashboardConfig/ottokartQuotationDashboardConfig";
import {getDefaultThisMonthDateRangeIsoBounds} from "~/utilities/defaultDateRange";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/quotation-dashboard",
)({
    loader: async ({context}) => {
        const {
            intellsysBaseUrl,
            workspace,
            authenticationStatus: {accessToken},
        } = context;

        const datasetResult = await getXochipilliDatasetDetails(
            OTTOKART_QUOTATION_DASHBOARD_DATASET_ID,
            intellsysBaseUrl,
            accessToken,
            workspace.id,
            context.queryClient,
        );
        if (datasetResult.success !== true) {
            throw datasetResult.error;
        }

        const {start, end} = getDefaultThisMonthDateRangeIsoBounds();

        return {
            dataset: datasetResult.data,
            defaultRange: {start, end},
            workspaceUser: context.currentWorkspaceUser,
            platformUser: context.profileStatus.platformUser,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
